import React, {useContext, useEffect, useState} from "react";
import ClientDataContext from "../store/client-data-context";
import {useSearchParams} from "react-router-dom";
import jwtDecode from "jwt-decode";
import {AlcoCallbackWrapper} from "../components/client-pages/alco123/AlcoCallbackWrapper";
import {BankCallbackWrapper} from "../components/client-pages/bank321/BankCallbackWrapper";

export const Callback = () => {

    const clientCtx = useContext(ClientDataContext);

    let [searchParams] = useSearchParams();
    let [userInfo, setUserInfo] = useState({})
    let [receivedToken, setReceivedToken] = useState({})
    let [errorCode, setErrorCode] = useState('')
    let [errorDescription, setErrorDescription] = useState('')
    let [userInfoLoaded, setUserInfoLoaded] = useState(false)

    const lang = localStorage.getItem('i18nextLng');

    useEffect(() => {
        const requestToken = (code: string) => {
            console.log('starting POST token')
            let headers = new Headers();
            headers.set('Authorization', 'Basic ' + btoa(clientCtx.client.clientId + ":" + clientCtx.client.basicAuthPass));
            headers.append('Content-Type', 'application/x-www-form-urlencoded');

            fetch('/token', {
                method: 'POST',
                headers: headers,
                body: new URLSearchParams({
                    'grant_type': 'authorization_code',
                    'code': code,
                    'redirect_uri': global.demoConfig.OIDC_REQUEST_REDIRECT_URI,
                    'code_verifier': 'Th7UHJdLswIYQxwSg29DbK1a_d9o41uNMTRmuH0PM8zyoMAQ',
                })
            }).then((response) => response.json())
                .then((responseJson) => {
                    console.log('token response', responseJson);
                    setReceivedToken(responseJson);
                    const decoded = jwtDecode(responseJson.id_token);
                    console.log('decoded id_token', decoded);
                    setUserInfo(decoded);
                    setUserInfoLoaded(true);

                })
                .catch((error) => {
                    console.error(error);
                });
        }

        var tokenCode = searchParams.get('code');
        var errorCode = searchParams.get('error');

        if (tokenCode != null) {
            requestToken(tokenCode)
        } else if (errorCode != null) {
            setErrorCode(errorCode);
            setErrorDescription(searchParams.get('error_description'))
        }
    }, [clientCtx, searchParams])

    if (userInfo['name'] !== '') {
        if (clientCtx.client.clientId === 'bank321') {
            return <BankCallbackWrapper userInfo={userInfo} errorCode={errorCode} lang={lang} clientCtx={clientCtx}/>
        } else if (clientCtx.client.clientId === 'alco123') {
            return <AlcoCallbackWrapper userInfo={userInfo} errorCode={errorCode} lang={lang} clientCtx={clientCtx}/>
        }
    }
}
